import { getStoreData, updateStoreSettings } from 'api/AuthApi';
import { getPublicStoreData } from 'api/GuestApi';
import * as actions from 'state/modules/store/actions';
import { toast } from 'react-toastify';
import { ErrorPrinter } from 'utils/error';

export const getStoreDataOperation = () => {
   return async (dispatch) => {
      dispatch(actions.getStoreDataStart());
      try {
         const { data } = await getStoreData();
         dispatch(actions.getStoreDataCompleted(data));
      } catch (error) {
         ErrorPrinter(error.response);
         dispatch(actions.getStoreDataFailed());
         toast.error('Failed to load store data.');
      }
   };
};

export const getPublicStoreDataOperation = () => {
   return async (dispatch) => {
      dispatch(actions.getStoreDataStart());
      try {
         const { data } = await getPublicStoreData();
         dispatch(actions.getStoreDataCompleted(data));
      } catch (error) {
         ErrorPrinter(error.response);
         dispatch(actions.getStoreDataFailed());
         toast.error('Failed to load store data.');
      }
   };
};

export const updateStoreSettingsOperation = (settings, { silent = false } = {}) => {
   return async (dispatch) => {
      dispatch(actions.updateStoreSettingsStart());
      try {
         const { data } = await updateStoreSettings(settings);
         dispatch(actions.updateStoreSettingsCompleted(data));
         if (!silent) toast.success('Store settings saved successfully.');
      } catch (error) {
         ErrorPrinter(error.response);
         dispatch(actions.updateStoreSettingsFailed());
         if (!silent) toast.error('Failed to save store settings.');
      }
   };
};
